import { NgModule } from '@angular/core';
import { BackdropComponent } from '@shared/components/UI/backdrop/backdrop.component';

@NgModule({
  declarations: [BackdropComponent],
  imports: [],
  exports: [BackdropComponent],
})
export class BackdropModule {}
